import React, {useState, useEffect} from "react";
import { useForm, Controller, control, NavLink } from "react-hook-form";
import axios from "axios";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';
import Header from "../../components/Header.jsx";
import HeaderTwo from "../../components/HeaderTwo.jsx";
import { DatePicker, Space } from 'antd';
import TableXDataGrid from "../form/TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";
//import urls from './../constants/urls';
import urls from '../../constants/urls.js';

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});


const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"

});
 
export default function SchoolOwnersRegistration() {
 
    const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
    
    const [schools, setSchools]=useState([]);

      const [cities, setCities]=useState([]);
      const [city, setCity]=useState('Select city');
      
      const [districts, setDistricts]=useState([]);
      const [districtsOG, setDistrictsOG]=useState([]);
      const [district, setDistrict]=useState('');
      
      const [wards, setWards]=useState([]);
      const [wardsOG, setWardsOG]=useState([]);
      const [ward, setWard]=useState('');

    const [formDataUserLoginEXT, setFormDataUserLoginEXT]=useState({
         
          users_id: 0,// = models.BigAutoField(primary_key=True)
          first_name: '',// = models.CharField(max_length=32)
          middle_name: '',// = models.CharField(max_length=32)
          last_name: '',// = models.CharField(max_length=32)
          full_name: 0,// = models.CharField(max_length=64)
          gender: 'X',// = models.CharField(max_length=16)
          mobile_number: '',// = models.CharField(max_length=16)
          user_email: 'X',// = models.CharField(max_length=32)
          date_of_birth: 'School Owners',// =models.DateTimeField(max_length=32, null=True)
          password_id: 0,// = models.IntegerField()
          user_password: '',// =models.CharField(max_length=128)
          login_category_id: 0,// = models.IntegerField()
          login_category_name: 'Default',// =models.CharField(max_length=32)
      })
    
    const [errors, setErrors]=useState({});
  
  
   
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(ColorModeContext.color)
        return {
          ...styles,
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? data.color
            : isFocused
            ? color.alpha(0.1).css()
            : undefined,
          color: isDisabled
            ? "#ccc"
            : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
          cursor: isDisabled ? "not-allowed" : "default",
    
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? data.color
                : color.alpha(0.3).css()
              : undefined
          }
        }
      },
      input: styles => ({ ...styles, ...dot() }),
      placeholder: styles => ({ ...styles, ...dot("#ccc") }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
    }
    
    //
    const dot = (color = 'transparent') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });

    
    const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
    }
    };
    //
    const [submitClicked, changeSubmitClicked]=useState(false);
    const [txtFullName, changeTxtFullName]=useState('');
    const [txtFullNameSimilar, changeTxtFullNameSimilar]=useState(' ');
    
    //
     const tableXDataGridColumns =[
        {
          field: 'users_id',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left'
      },
      {
        field: 'first_name',
        headerName: 'First Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'middle_name',
      headerName: 'Middle Name',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  {
  field: 'mobile_number',
  headerName: 'Telephone',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
    {
    field: 'user_email',
    headerName: 'Email',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
    },

    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
      },
     ]
    //
    const onChangeDate = (date, dateString) => {
  
      console.log("date=" + date);
      console.log("dateString=" + dateString);
      console.log(date, dateString);
      setPatientDOB(dateString);
      console.log("PatientDOB=" + patientDOB);
  };
    //
    const validateString=(stringValue, similarStringValue)=>{
      let validateString=false
      if(stringValue==="" || stringValue==similarStringValue){
        validateString=true
      }
    }

    function validateOnSubmit(){
          let validateOnSubmitStatus=false;
          validateString=(txtFullName, txtFullNameSimilar)
          
          return validateOnSubmitStatus
    }
    //
    const [firstName, setFirstName] = useState('');
    
  

    
    //
    const onSubmit = (data) => { 
      //alert("");
      //console.log(event.target[0].value)
      console.log(data['txtFirstName']);
      console.log("formDataUserLoginEXT0=" + formDataUserLoginEXT[0]);
      return;
      //alert("form=" + form[0]);
      //inputProps
      changeSubmitClicked(true);
      let validateStatus=validateOnSubmit();
      console.log("data=" + data)
      console.log("dt__=" + JSON.stringify(data))
      console.log("validateStatus=" + validateStatus)
      if (validateStatus==true){
        console.log("error=" + true)
        return;
      }
      return;
      const jsonObj=data;
      const myobj={
            first_name: jsonObj['txtFirstName'],
            middle_name: jsonObj['txtMiddleName'],
            last_name: jsonObj['txtLastName'],
            telephone: jsonObj['txtMobileNo'],
            nationality: "TZ",
            gender: patientGender['value'],
            dob: patientDOB + ' 00:00:00.00000',
            status: jsonObj['paymentMethod'],
            age: jsonObj['txtAge'],
            address: jsonObj['txtFirstName'],
            patient_code: "ABCDEFG",
            //status: jsonObj['payment_method']
      }
      const APIURL="/myapi/crnewpatient";
      const bodyJSON=JSON.stringify(data);
      const requestOptions ={
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(myobj),
      };
     // return;
      try {
               console.log("bb=" + requestOptions);
               fetch(APIURL, requestOptions)
               .then( (response) =>  response.json())
               .then( (data) => console.log(data))
               .then( (data) => alert(data))
          }
     catch(err) {
     console.log(err.message);
       }
    }
     
    const insuranceCategoryValues=[
      { value: 'Select Insurance Category', label: 'Select Insurance Category' },
      { value: 'NHIF', label: 'NHIF' },
      { value: 'ABC', label: 'ABC' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const genderValues=[
      { value: 'Select gender', label: 'Select gender' },
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    }
    
    const [patientGender, setPatientGender]=useState(
        [
        {label :'Select gender', value:'Select gender', name: 'gender' },
        {label :'Male', value:'Male', name: 'gender' },
        {label :'Female', value:'Female', name: 'gender' },
        ]
    );
    //console.log(watch("example")) // watch input value by passing the name of it

    const [patientDOB, setPatientDOB]=useState('');
    
    const findGender = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setPatientGender(event);
    }
    

    const [insuranceCategory, setInsuranceCategory]=useState(
      { value: 'Select Insurance Category', label: 'Select Insurance Category' }
      );
    //console.log(watch("example")) // watch input value by passing the name of it

    const findInsuranceCategory = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setInsuranceCategory(event);
    }

    

    {/**
    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })
  **/}
    
    

   
    {/**
    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "grey",
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
  **/}
   
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    const [patientsRecordsUrl, setPatientsRecordsUrl]=useState('DistrictAdminsViewEXT');
    //const [patientDOB,]
    const onChangeDOB = (date, dateString) => {
      console.log(date, dateString)
      setPatientDOB(dateString)
      console.log("pdob=" + patientDOB)
    };
    

    /***
    ***/
    /** **/
    const myBox=()=> {
      return <div className="box"> ABC </div>;
      {/**{showRecords ? <myBox /> : <PRFHooks/>}**/}
    }
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Form')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Records')
       }
    }
    const [showForm, setShowForm] = useState(true);
    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    
    function changeFirstName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setFirstName(e ? e: "");
    }

    const[middleName, setMiddleName]=useState('');

    function changeMiddleName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setMiddleName(e ? e: "");
    }

    function handleFirstNameChange(e){
       //console.log("et=" + e.value);
       console.log("e=" + e.target.value);
       try{
        var ee=e.target.value;
       
       }
       catch(Exception){
        console.log("error=" + Exception);
       }
       console.log("fn=" + firstName);
       console.log("ee=" + ee);
       
       //props.value ? props.value : ""
      // e.target.value ? changeFirstName(e.target.value) : ""
       //changeFirstName(ee);
       console.log("fn1=" + firstName);
       
      }


      
  const reloadDistricts=(cityId)=>{
    let newList=[]
     newList=districtsOG.filter(districtsOG=>districtsOG.city_id===cityId);
     setDistricts(newList);
   }
   
   const reloadWards=(districtId)=>{
     let newList=[]
      newList=wardsOG.filter(wardsOG=>wardsOG.district_id===districtId);
      setWards(newList);
     
    }
 
      

      const [fName, setFName]=useState("f name");

      const handleChangeInput = (e) =>{
        const {name, value } =e.target
        setFormDataUserLoginEXT({
         ...formDataUserLoginEXT,
         [name]: value
        })
        //
        
        //
        setErrors({});
      }
     
      const handleChangeSelect = (e) =>{
        const {name, value } = e
    
        //console.log("e.target.name=" + e.target.name)
        console.log("name=" + name +  ", value=" + value)
        //UserLoginEXT

        if(name==="ward"){
            setFormDataUserLoginEXT({
            ...formDataUserLoginEXT,
            [ward]: e.id
            })
       }
        //
        if(name==="city"){
            console.log("city=" + city);
            console.log("city e.id=" + e.id);
            
            setCity(e.value);
            reloadDistricts(e.id)
        }
        
        if(name==="district"){
            setDistrict(e.value);
            
            reloadWards(e.id);

            setFormDataUserLoginEXT({
              ...formDataUserLoginEXT,
              ['full_name']: e.id
              });
        }
        
        if(name==="ward"){
          setFormDataUserLoginEXT({
            ...formDataUserLoginEXT,
            [name]: e.id
            })
            setWard(e.value);
        }
    
       //
       setErrors({});
        //
      }
  
  
  const loadSchools=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select school', value: 'Select school', name: 'school'})
    {
        data.map(function(dt){
          newList.push({id: dt.school_id, label: dt.school_name, value: dt.school_name , name: 'school'})
        })
    }

    setSchools(newList)
  }
  
  
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "SchoolsViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json=" + json);
     loadSchools(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])


      
const validateForm = (data) =>{
    const errors={};
    

    console.log("01 " + ", data.first_name=" + data.first_name)

    if(data.first_name==="" || data.first_name==""){
        console.log("if " + ", data.first_name=" + data.first_name)
        errors.first_name='Please enter first name';
    }

    if(data.middle_name==="" || data.middle_name==""){
        console.log("if " + ", data.middle_name=" + data.middle_name)
        errors.middle_name='Please enter middle name';
    }
    
    if(data.last_name==="" || data.last_name==""){
        console.log("if " + ", data.last_name=" + data.last_name)
        errors.last_name='Please enter last name';
    }
    
    /*** *
    if(data.full_name==="0" || data.full_name=="0" || data.full_name===0 || data.full_name==0){
      console.log("if " + ", data.full_name=" + data.last_name)
      errors.district='Please select district';
    }
    ***/
    {/** *
    if(data.gender==="" || data.gender=="" || data.gender==="Select gender" || data.gender=="Select gender" ){
        console.log("if " + ", data.name=" + data.gender)
        errors.gender='Please select gender';
    }
    ***/}
    if(data.user_password==="" || data.user_password==""){
        console.log("if " + ", data.name=" + data.user_password)
        errors.user_password='Please enter password';
    }
   
    {/** *
    if(data.user_email==="" || data.user_email==""){
        console.log("if " + ", data.name=" + data.user_email)
        errors.user_email='Please enter email';
    }
    ***/}

    if(data.mobile_number==="" || data.mobile_number==""){
      console.log("if " + ", data.name=" + data.mobile_number)
      errors.mobile_number='Please enter mobile number';
     }
     else{
      console.log("else " + ", data.mobile_number=" + data.mobile_number)
     }
     
     /*** *
     if(data.user_password==="" || data.user_password==""){
      console.log("if " + ", data.name=" + data.user_password)
      errors.user_password='Please enter password';
     }
     else{
      console.log("else " + ", data.user_password=" + data.user_password)
     }  ***/
    
    return errors;
  
  }
  

   
    const submitOrganizationDirector=()=>{

        console.log("111 formDataUserLoginEXT.mobile_number=" + formDataUserLoginEXT['mobile_number'])
        console.log("112 formDataUserLoginEXT.user_password=" + formDataUserLoginEXT['user_password'])
         
         let newErrors=validateForm(formDataUserLoginEXT);
         setErrors(newErrors);
         
         console.log("errors.lenght=" + Object.keys(newErrors).length)
         if(Object.keys(newErrors).length===0){
           console.log("len0")
           CreateOrganizationDirector()
         }
         else{
           console.log("len1")
         }
         
    }


    
   const CreateOrganizationDirector=()=>{
     
     
    //let url = API_URL;
    let APIURL= APIROOTURL + "CreateOrganizationDirectorsViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataUserLoginEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data.msg=" + res.data.msg)
        let usersId=res.data.usersId;
       let fullName=res.data.username; //res.data.fullName;
       
       let loginCategoryName=res.data.category;
       let userRolesList=[];//res.data.qr;
      
       let loginDetails=[];//res.data.loginDetails;
     
       let loginDetailsForm={
        loginCategory: loginCategoryName,
        
        userPassword: formDataUserLoginEXT['user_password'],
        fullName: fullName,
        usersId: usersId,
      }
                        //User login was successful
       if (res.data.msg==="Organization Director was successfully created"){
        //
        alert("Organization Director was successfully created")
       //  
       }
       else if (res.data.msg==="A user with similar mobile numbers has already been created"){
        //
        alert("A user with similar mobile numbers has already been created")
       //  
       }
       else{
        alert("Creating School Admin failed");
       }
       //

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));

   }   


   const loadCities=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select city', value: 'Select city', name: 'city'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'city'})
        })
    }

    setCities(newList)
  }

  
  const loadDistricts=(data)=>{
    let newList=[]
    newList.push({ name: 'district', id: 0, label: 'Select district', value: 'Select district' , city_id: 0})
    {   
        data.map(function(dt){
          newList.push({name: 'district', id: dt.id, label: dt.name, value: dt.name, city_id: dt.city_id})
        })
    }
    
    setDistricts(newList)
    setDistrictsOG(newList)
  }

  
  
      useEffect(()=>{
        
      let APIURL= APIROOTURL + "CitiesViewEXT"
      let headerOptions={
          method: 'GET',
      }
  
      fetch(APIURL, headerOptions)
      .then( response => response.json())
      .then( json =>{
       console.log("json=" + json);
       loadCities(json)
      })
      .catch(error=> console.log("error=" + error))
      
      },[])
  
  
  
      useEffect(()=>{
        
          let APIURL= APIROOTURL + "DistrictsViewEXT"
          let headerOptions={
              method: 'GET',
          }
      
          fetch(APIURL, headerOptions)
          .then( response => response.json())
          .then( json =>{
           console.log("json=" + json);
           loadDistricts(json)
          })
          .catch(error=> console.log("error=" + error))
          
          },[])
  
      
 
    
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
      {/***
      <Button type="submit" color="secondary" variant="contained"
      onClick={tOPButtonOnClick}
      >
        {topButtonLabel}
      </Button>
      ***/}
      <span>
      
      </span>
      
      <br/>
      
      {!showForm && (
      <div style={{height: '1200px'}}>
        <br/>
        <TableXDataGrid url={patientsRecordsUrl} tableColumns={tableXDataGridColumns}></TableXDataGrid>
      </div>
      )}
      
      {showForm && (<div>
      
      
      {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
      {/***
      <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>
          <StyledInput 
           placeholder="Full Name"
           defaultValue=""
           onChange={event => event.target.value?
            setFName("" + event.target.value + "")
             : 
             setFirstName("error")}
            
            />
            <span>{fName}</span>
          </TXTRoundedDiv>
      ***/}
        {/***<form onSubmit={handleSubmit(onSubmit)}>   ***/}

        {/* register your input into the hook by invoking the "register" function */}
        
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={3}>
            
        
          

            {/***/}
           
            {/***/}
             
           
           
          </StyledBox>
          
          <StyledBox flex={6}>    
           
          <HeaderTwo title="CREATE ORGANIZATION DIRECTOR" subtitle="" />
           
          <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>
           <StyledInput 
           name="first_name"
           onChange={handleChangeInput}
           placeholder="First Name"
           
            />
           {errors.first_name && (<span> {errors.first_name} </span>) }
           </TXTRoundedDiv>
           
           {/** **/}
           <TXTRoundedDiv>
           <StyledInput 
           name="middle_name"
           onChange={handleChangeInput}
           placeholder="Middle Name"
           
            />
           {errors.middle_name && <span> {errors.middle_name} </span>}
           </TXTRoundedDiv>

           
           <TXTRoundedDiv>
           <StyledInput 
           name="last_name"
           onChange={handleChangeInput}
           placeholder="Last Name"
          
            />
           {errors.last_name && <span> {errors.last_name} </span>}
           </TXTRoundedDiv>

           <TXTRoundedDiv>
           <StyledInput 
           name="mobile_number"
           onChange={handleChangeInput}
           placeholder="Mobile No"
           
            />
           {errors.mobile_number && <span> {errors.mobile_number} </span>}
           </TXTRoundedDiv>
           
           {/***
           <TXTRoundedDiv>
              <Select
                  name="city"
                  placeholder="Select city"
                  options={cities}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.city && (<span> {errors.city} </span>)}
         </TXTRoundedDiv>


         <TXTRoundedDiv>
              <Select
                  name="district"
                  placeholder="Select district"
                  options={districts}
                  
                  styles={customStyles}
                  
                  onChange={handleChangeSelect}
                  
              />
              {errors.district && (<span> {errors.district} </span>)}
         </TXTRoundedDiv>
           ***/}

         {/*** *
           ***/}

           <TXTRoundedDiv>
           <StyledInput 
           secureTextEntry={true}
           placeholder="Enter password"
           name="user_password"
           onChange={handleChangeInput}
          
            />
           {errors.user_password && <span> {errors.user_password} </span>}
           </TXTRoundedDiv>

          

           <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           onClick={submitOrganizationDirector}
           >
                SUBMIT
            </Button>
        
          </StyledBox>
          
          <StyledBox flex={3}>

          </StyledBox>

        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">
        <Box display="flex" justifyContent="end" mt="20px">
              
              {/***
              <input 
               type="submit"
               sx={{
                  backgroundColor: "#62529c",
                  border: "none",
                  color: "#fff",
                  padding: "15px 30px",
                  textDecoration: "none",
                  margin: "4px 2px",
                  cursor: "pointer",
               }}
              />
               ***/}
              
             
        </Box>

        </Stack>
        
        
       

      {/***</form> ***/}
      </div>) }
      </Box>
      
    )
  }